import React from "react";
import { Pressable, TouchableOpacity, View } from "react-native";
import Text from "@components/CustomText";
import ChevronRight from "@assets/svg/ChevronRight";
import color from "@constants/color";
import analytics from "@services/analytics";
import { useNavigation } from "@react-navigation/native";
import { Dimensions } from "react-native";
import LoadingComponent from "./LoadingComponent";
import { scale, ScaledSheet } from "@utils/scale";

const { width: SCREEN_WIDTH } = Dimensions.get('screen');

const TodaysProgress = React.memo(({ item }) => {
  const navigation = useNavigation();

  const handlePress = () => {
    if (item?.nav_to) {
      analytics.trackEvent("Todays Progress Card Clicked", {
        source: "Home Page Widget",
      });
      navigation.navigate(item?.nav_to, { nav_params: item?.nav_params });
    }
  };

  const handleWeeklyPress = () => {
    if (item?.nav_to) {
      analytics.trackEvent("Todays Progress Card Clicked", {
        source: "Home Page Widget",
      });
      navigation.navigate(item?.nav_to, { nav_params: { type: 'WEEKLY' } });
    }
  };

  const isloading = (key) => {
    return item?.loading?.includes(key);
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity
        testID="hpw-todays-progress-header"
        style={styles.headerContainer}
        activeOpacity={0.8}
        disabled={!item?.nav_to}
        onPress={handlePress}
      >
        <Text variant="title_20" style={styles.headerTitle}>
          {"Today's Progress"}
        </Text>
        {item?.nav_to && (
          <View style={styles.chevronContainer}>
            <ChevronRight
              pathFill={color.mediumBlack}
              style={styles.chevronIcon}
            />
          </View>
        )}
      </TouchableOpacity>
      {/* Divider */}
      <View style={styles.divider} />
      {/* Earnings Cards */}
      <View style={styles.cardsContainer}>
        {/* Today's Earning Card */}
        <View style={styles.todayCard}>
          <Pressable onPress={handlePress}>
            <Text variant="subtitle_14" style={styles.todayLabel}>
              {item?.caption_txt || "Today's Earning"}
            </Text>
            <LoadingComponent
              visible={!isloading("today_value")}
              style={[
                styles.loadingStyle,
                isloading("today_value") && {
                  marginVertical: 8,
                  width: "80%",
                },
              ]}
            >
              <Text variant="heading_30" style={styles.todayValue}>
                {item?.caption_value || "₹0"}
              </Text>
            </LoadingComponent>
            {/* Decorative Rupee Symbol */}
            <Text style={styles.decorativeRupee}>₹</Text>
          </Pressable>
        </View>
        {/* Weekly Earning Card */}
        <View style={styles.weekCard}>
          <Pressable onPress={handleWeeklyPress}>
            <Text variant="subtitle_14" style={styles.weekLabel}>
              {item?.caption_2_txt || "Earnings this Week"}
            </Text>
            <LoadingComponent
              visible={!isloading("week_value")}
              style={[
                styles.loadingStyle,
                isloading("week_value") && {
                  marginVertical: 8,
                  width: "70%",
                },
              ]}
            >
              <Text variant="heading_30" style={styles.weekValue}>
                {item?.caption_2_value || "₹0"}
              </Text>
            </LoadingComponent>
          </Pressable>
        </View>

      </View>
    </View>
  );
});

export default TodaysProgress;

const styles = ScaledSheet.create({
  container: {
    width: SCREEN_WIDTH - scale(32),
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.2)",
    borderRadius: 24,
    marginHorizontal: 6,
    marginVertical: 8,
    padding: 16,
    backgroundColor: color.white,
  },
  headerContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8,
    paddingHorizontal: 4,
  },
  headerTitle: {
    color: color.mediumBlack,
    width: '80%'
  },
  chevronContainer: {
    backgroundColor: color.lightGrayWhite,
    alignSelf: "flex-start",
    padding: 4,
    borderRadius: 8,
  },
  chevronIcon: {
    height: 20,
    width: 20,
  },
  divider: {
    backgroundColor: color.shadowLighter,
    height: 2,
    width: "100%",
    marginBottom: 10
  },
  cardsContainer: {
    flexDirection: "row",
    gap: 12,
  },
  todayCard: {
    flex: 1,
    backgroundColor: "#2D3436",
    borderRadius: 20,
    padding: 18,
    paddingBottom: 12,
    overflow: "hidden",
  },
  todayLabel: {
    color: color.white,
    marginBottom: 8,
  },
  todayValue: {
    color: color.white,
    zIndex: 1,
  },
  decorativeRupee: {
    position: "absolute",
    right: 16,
    bottom: -15,
    fontSize: 64,
    fontWeight: "700",
    color: "rgba(255, 255, 255, 0.1)",
    opacity: 0.5,
  },
  weekCard: {
    flex: 1,
    backgroundColor: color.white,
    padding: 16,
    justifyContent: "center",
  },
  weekLabel: {
    color: color.mediumBlacklightBlack,
    marginBottom: 4,
  },
  weekValue: {
    color: color.mediumBlack,
  },
  loadingStyle: {
    flex: 1,
  },
});

